import { useState, useEffect } from 'react'
import { getTodayString } from '@/lib/date'

export const useToday = () => {
  const [today, setToday] = useState(getTodayString())

  useEffect(() => {
    // Update today at midnight
    const now = new Date()
    const tomorrow = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1
    )
    const msUntilMidnight = tomorrow.getTime() - now.getTime()

    const timer = setTimeout(() => {
      setToday(getTodayString())
    }, msUntilMidnight)

    return () => clearTimeout(timer)
  }, [today])

  return today
}
